// extracted by mini-css-extract-plugin
module.exports = {"container":"_1vqq4U7ARu","mobile-dropdown":"_1p3i4Cxjxu","mobileDropdown":"_1p3i4Cxjxu","mobileDropdownItem":"m0j7rKp8e-","user-header":"_21OlKuPRKJ","userHeader":"_21OlKuPRKJ","user-icon":"_17s848IRbJ","userIcon":"_17s848IRbJ","user-message":"_3PnlJLIGaW","userMessage":"_3PnlJLIGaW"};
    if(module.hot) {
      // 1597843239967
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  